import React from 'react';
import {
  InputAdornment as MuiInputAdornment,
  InputAdornmentProps as MuiInputAdornmentProps,
  styled
} from '@mui/material';

export type InputAdornmentProps = Omit<MuiInputAdornmentProps, 'hasBorder'> & {
  hasBorder?: boolean;
};

const InputAdornment: React.FC<InputAdornmentProps> = styled(
  MuiInputAdornment,
  {
    name: 'MuiInputAdornment',
    shouldForwardProp: prop => prop !== 'hasBorder'
  }
)<InputAdornmentProps>(() => ({}));

InputAdornment.defaultProps = {
  hasBorder: false
};

export default InputAdornment;
